
import { PublicInstitutionsListComponent } from './public-instituitions/public-institutions-list/public-institutions-list.component';
import {Routes} from "@angular/router";
import {LoginComponent} from "./views/login/login.component";
import {WelcomeComponent} from "./views/welcome/welcome.component";
import {ResetPasswordComponent} from "./views/reset-password/reset-password.component";
import {BlankComponent} from "./components/common/layouts/blank.component";
import {BasicComponent} from "./components/common/layouts/basic.component";
import {UserListComponent} from "./user-list/user-list.component";
import {CreateApplicationComponent} from './application/create/create-application.component';
import {FileUploadComponent} from "./shared/file-upload/file-upload.component";
import { ListApplicationsComponent } from "./application/list/list-applications.component";
import {ApplicationDetailComponent} from "./application/application-detail/application-detail.component";
import {FacilityListComponent} from './facility/facility-list/facility-list.component';
import {ModuleConfigComponent} from './settings/module-config/module-config.component';
import {RenewApplicationComponent} from './application/renew-application/renew-application.component';
import {SpecificProductConfigComponent} from './settings/specific-product-config/specific-product-config.component';
import {FacilityCategorizeComponent} from './facility/facility-categorize/facility-categorize.component';
import {SystemSettingsComponent} from './settings/system-settings/system-settings.component';
import {LegacyDataUserAssociationComponent} from './settings/legacy-data-user-association/legacy-data-user-association.component';
import {ChangeApplicationComponent} from './application/change-application/change-application.component';
import { EditApplicationComponent } from "./application/edit-application/edit-application.component";
import { DashboardComponent } from "./application/dashboard/dashboard/dashboard.component";
import { ReportListConfigComponent } from "./settings/report-config/report-list/report-list-config.component";
import { ReportDetailConfigComponent } from "./settings/report-config/report-detail-config/report-detail-config.component";
import { ReportRoleConfigComponent } from "./settings/report-role-config/report-role-config.component";
import { ReportsComponent } from "./report/reports/reports.component";
import { ReportDetailComponent } from "./report/report-detail/report-detail.component";
import { ReplaceApplicationComponent } from "./application/replace-application/replace-application.component";
import { ReturnApplicationComponent } from "./application/return-application/return-application.component";
import { WarehouseAdditionApplicationComponent } from "./application/warehouse-addition-application/warehouse-addition-application.component";
import {ProfessionalConfigComponent} from './settings/professional-config/professional-config.component';
import { PublicInstitutionsDetailComponent } from './public-instituitions/public-institutions-detail/public-institutions-detail.component';
import { PreInspectionAppListComponent } from './inspection/pre-inspection-app-list/pre-inspection-app-list.component';
import { PreInspectionDetailComponent } from './inspection/pre-inspection-detail/pre-inspection-detail.component';
import { CreateInspectionComponent } from './inspection/create-inspection/create-inspection.component';
import { InspectionListComponent } from './inspection/inspection-list/inspection-list.component';
import { InspectionDetailComponent } from './inspection/inspection-detail/inspection-detail.component';
import { CreateAbroadCgmpInspectionComponent } from './inspection/create-abroad-cgmp-inspection/create-abroad-cgmp-inspection.component';
import { RenewAbroadCgmpInspectionComponent } from './inspection/renew-abroad-cgmp-inspection/renew-abroad-cgmp-inspection.component';
import {ErisLoginComponent} from './services/sso/eris-login.component';
import {ErisLoginGuard} from './services/sso/eris-login.guard';
import { CreateLocalGmpInspectionComponent } from './inspection/create-local-gmp-inspection/create-local-gmp-inspection.component';
import { EditAccountComponent } from './edit-account/edit-account.component';
import { AccountInfoGuard } from './services/account-info.guard';

import { ManageTinComponent } from './facility/manage-tin/manage-tin.component';
import { LegacyDataCapaComponent } from './inspection/legacy-data-capa/legacy-data-capa.component';
import { ProductionLineConfigComponent } from './settings/production-line-config/production-line-config.component';
import { InspectionDetailReadonlyComponent } from './inspection/inspection-detail-readonly/inspection-detail-readonly.component';

export const ROUTES:Routes = [
  // Main redirect
  {path: '', redirectTo: 'welcome', pathMatch: 'full'},

  // App views
  {
    path: '', component: BasicComponent, canActivateChild: [ErisLoginGuard, AccountInfoGuard],
    children: [
      {path: 'applications/createNew', component: CreateApplicationComponent},
      {path: 'edit/:id/:mode', component: CreateApplicationComponent},
      {path: 'edit/:id', component: CreateApplicationComponent},

      {path: 'applications/createNew/:temp', component: CreateApplicationComponent},
      {path: 'tempCOC/edit/:temp/:id/:mode', component: CreateApplicationComponent},
      {path: 'tempCOC/edit/:temp/:id', component: CreateApplicationComponent},

      {path: 'applications/createRenewal', component: RenewApplicationComponent},
      {path: 'renewal/edit/:id/:draft', component: RenewApplicationComponent},

      {path: 'applications/createChange', component: ChangeApplicationComponent},
      {path: 'change/edit/:id/:draft', component: ChangeApplicationComponent},

      {path: 'applications/createChange/:temp', component: ChangeApplicationComponent},
      {path: 'changeTemp/edit/:temp/:id/:draft', component: ChangeApplicationComponent},

      {path: 'applications/createReplacement', component: ReplaceApplicationComponent},
      {path: 'replacement/edit/:id/:draft', component: ReplaceApplicationComponent},

      {path: 'applications/createReturnCOC', component: ReturnApplicationComponent},
      {path: 'returnCOC/edit/:id/:draft', component: ReturnApplicationComponent},

      {path: 'applications/createReturnCOC/:temp', component: ReturnApplicationComponent},
      {path: 'returnTempCOC/edit/:temp/:id/:draft', component: ReturnApplicationComponent},

      {path: 'applications/createWarehouseAddition', component: WarehouseAdditionApplicationComponent},
      {path: 'warehouseAddition/edit/:id/:draft', component: WarehouseAdditionApplicationComponent},

      {path: 'applications/createWarehouseAddition/:temp', component: WarehouseAdditionApplicationComponent},
      {path: 'warehouseAdditionTemp/edit/:temp/:id/:draft', component: WarehouseAdditionApplicationComponent},

      {path: 'applications/:category', component: ListApplicationsComponent},
      {path: 'applications/list/:id', component: ApplicationDetailComponent},
      {path: 'update/:id', component: EditApplicationComponent},
      {path: 'users', component: UserListComponent},
      {path: 'fileUpload', component: FileUploadComponent},
      
      {path: 'facilities/list', component: FacilityListComponent},
      {path: 'facilities/categorize', component: FacilityCategorizeComponent},
      {path: 'manageTin', component: ManageTinComponent},

      {path: 'settings/modules', component: ModuleConfigComponent},
      {path: 'settings/specificProducts', component: SpecificProductConfigComponent},
      {path: 'settings/systemSettings', component: SystemSettingsComponent},
      {path: 'settings/professionalConfig', component: ProfessionalConfigComponent},
      {path: 'settings/legacyDataUserAssociation', component: LegacyDataUserAssociationComponent},
      {path: 'settings/productionLineConfig', component: ProductionLineConfigComponent},
      {path: 'dashboard', component: DashboardComponent},
      {path: 'settings/reports', component: ReportListConfigComponent},
      {path: 'settings/reports/:id', component: ReportDetailConfigComponent},
      {path: 'settings/roles', component: ReportRoleConfigComponent},
      {path: 'reports', component: ReportsComponent},
      {path: 'report/:id', component: ReportDetailComponent},

      {path: 'publicInsts', component: PublicInstitutionsListComponent},
      {path: 'publicInsts/detail/:id', component: PublicInstitutionsDetailComponent},
      
      {path: 'welcome', component: WelcomeComponent},
      // Inspection Module - Start
      {path: 'inspections/preInspection/list', component: PreInspectionAppListComponent},
      {path: 'inspections/preInspection/:id', component: PreInspectionDetailComponent},

      {path: 'inspections/postLicensing/create/:inspectionTypeCode', component: CreateInspectionComponent},   
      {path: 'inspections/investigation/create/:inspectionTypeCode', component: CreateInspectionComponent},
      {path: 'inspections/informalMarket/create/:inspectionTypeCode', component: CreateInspectionComponent},

      {path: 'inspections/localGMP/create/:inspectionTypeCode', component: CreateLocalGmpInspectionComponent},  
      {path: 'inspections/localGMP/edit/:inspectionTypeCode/:id', component: CreateLocalGmpInspectionComponent},  

      {path: 'inspections/abroadCGMP/create/:inspectionTypeCode', component: CreateAbroadCgmpInspectionComponent},
      {path: 'inspections/abroadCGMP/edit/:inspectionTypeCode/:id/:legacy', component: CreateAbroadCgmpInspectionComponent},

      {path: 'inspections/abroadCGMP/renewal/create/:inspectionTypeCode', component: RenewAbroadCgmpInspectionComponent },
      {path: 'inspections/abroadCGMP/renewal/edit/:inspectionTypeCode/:id', component: RenewAbroadCgmpInspectionComponent },

      {path: 'inspections/postLicensing/list/:inspectionTypeCode', component: InspectionListComponent}, 
      {path: 'inspections/localGMP/list/:inspectionTypeCode', component: InspectionListComponent},  
      {path: 'inspections/abroadCGMP/list/:inspectionTypeCode', component: InspectionListComponent},   
      {path: 'inspections/investigation/list/:inspectionTypeCode', component: InspectionListComponent},
      {path: 'inspections/informalMarket/list/:inspectionTypeCode', component: InspectionListComponent},
      
      {path: 'inspections/localGMP/legacyCapa/:inspectionTypeCode', component: LegacyDataCapaComponent},  
      {path: 'inspections/abroadCGMP/legacyCapa/:inspectionTypeCode', component: LegacyDataCapaComponent},   

      {path: 'inspections/:id', component: InspectionDetailComponent}
      // Inspection Module - End
      
    ]
  },
  
  {path: 'inspections/view/:id', component: InspectionDetailReadonlyComponent},
  {
    path: '', component: BasicComponent, canActivateChild: [ErisLoginGuard],
    children: [
      { path: 'account/edit', component: EditAccountComponent}
    ]
  },
  {
    path: '', component: BlankComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'resetPassword', component: ResetPasswordComponent },
      { path: 'resetPassword/:id/:token', component: ResetPasswordComponent }
    ]
  },

  // Handle all other routes
  {path: '**', redirectTo: 'welcome', pathMatch: 'full'}
];
